import MainLayout from 'layouts/MainLayout';

import Start from '../pages/Start';
import Conversation from '../pages/Conversation';

const routes =  [{
    layout: MainLayout,
    routes: [{
        path: '/agents/:agentId/eurogielle-ordini-produzione',
        element: Start,
        exact: true,
        analytics: { name: ["Agente", "Rossato orari"] },
    }, {
        path: '/agents/:agentId/eurogielle-ordini-produzione/conversations/:conversationId',
        element: Conversation,
        exact: true,
        analytics: { name: ["Agente", "Conversazione"] },
    }]
}]

export default routes;